<template>
<tr :style="{height: '21px'}">
  <th class="br" :style="{width: '120px', minWidth: '110px'}"><span :style="{display: 'none'}">{{date.format('yyyy-')}}</span>{{date.format('MM-DD')}}</th>
  <template v-for="({user, signUp, signOut, delta}) in userdatas">
    <td :key="`${user._id}-1`" @dblclick="$emit('makeup', {type: 'Up', date: date.format('yyyy-MM-DD'), user})">{{signUp?signUp:'-'}}</td>
    <td :key="`${user._id}-2`" @dblclick="$emit('makeup', {type: 'Out', date: date.format('yyyy-MM-DD'), user})">{{signOut?signOut:'-'}}</td>
    <td class="br" :key="`${user._id}-3`">
      <span v-if="delta">{{parseInt(Math.abs(delta/60))}} 小時 {{Math.abs(delta%60)}} 分鐘</span>
    </td>
  </template>
</tr>
</template>

<script>
export default {
  props: ['items', 'date', 'users'],
  computed: {
    itemsdate () {
      if (this.items && this.items.length > 0) {
        return this.items.map(e => e.date)
      } else {
        return []
      }
    },
    iso () {
      return this.moment(this.date).startOf('day').toISOString()
    },
    index () {
      if (this.items && this.items.length > 0) {
        return this.items?.map(e => e.date).indexOf(this.moment(this.date).startOf('day').toISOString())
      } else {
        return -1
      }
    },
    item () {
      return this.items && this.items.length > 0 && this.index >= 0 ? this.items[this.index].emps : null
    },
    userdatas () {
      if (this.item) {
        return this.users.map((user) => {
          const data = this.item.find(e => e._id === user._id)
          return {
            signUp: data && data.signUp ? this.moment(data.signUp).format('HH:mm') : null,
            signOut: data && data.signOut ? this.moment(data.signOut).format('HH:mm') : null,
            delta: data ? data.delta : null,
            user
            // delta: data && data.signUp && data.signOut ? Math.abs(this.moment(data.signUp).diff(this.moment(data.signOut), 'minute')) : 0
          }
        })
      } else {
        return this.users.map(e => { return { user: e } })
      }
    }
  }

}
</script>

<style lang="scss" scoped>
td {
  width: 150px;
  min-width: 150px;
}
</style>
